import React from 'react';
import styled from 'styled-components';
import HeaderProduct from '../typography/HeaderProduct';
import { GRADIENTS } from '../../utils/colors';

const WrapperButton = styled.button`
  margin: 0;
  border: none;
  position: relative;
  border-radius: 4px;
  margin-right: 10px;
`;

const gradients = {
  order: 'linear-gradient(to top left, #ec008c, #fc6767)',
  orange: 'linear-gradient(to bottom right, #e44d26, #f16529)',
  blue: 'linear-gradient(to bottom right, #8e2de2, #4a00e0)',
  yellow: 'linear-gradient(to bottom right, #f09819, #edde5d)',
  red: 'linear-gradient(to bottom right, #e52d27, #b31217)',
  green: 'linear-gradient(to bottom right, #a8e063, #56ab2f)',
  grey: 'linear-gradient(to bottom right, #232526, #414345)',
};

const linears = {
  order: '#fc6767',
  orange: '#f16529',
  blue: '#4a00e0',
  yellow: '#edde5d',
  red: '#b31217',
  green: '#56ab2f',
  grey: '#414345',
};

const MenuButton = ({ action, style, name, gradient, header, active }) => {
  const color = gradient ? GRADIENTS[gradient] : GRADIENTS.orange;
  const border = gradient ? `1px solid ${linears[gradient]}` : `1px solid #fe8c00`;
  return (
    <WrapperButton
      onClick={action}
      style={{
        background: active ? color : 'none',
        border: active ? 'none' : border,
        padding: header ? '4px' : '10px',
        marginBottom: header ? '0' : '10px',
        width: header ? '66px' : '100px',
        height: header ? '34px' : 'auto',
        cursor: 'pointer',
        ...style,
      }}
    >
      <HeaderProduct
        name={name}
        color={active ? '#ffffff' : '#000000'}
        size={ header ? '0.8rem' : '0.9rem' }
        style={{ textAlign: 'center' }}
      />
    </WrapperButton>
  );
};
export { MenuButton };
